import { octetsToMegas } from '@common/utils';
import { z } from 'zod';

export const Z_FILE = (args: ValidationFileArgs) => {
  const { requiredMessage, maxSize, fileTypes } = args;
  return z
    .instanceof(File, { error: requiredMessage })
    .refine((file) => fileTypes.includes(file.type), { error: `Le format du fichier n'est pas autorisé (format autorisé: ${args.extensions.join(', ')})` })
    .refine((file) => file.size <= maxSize, { error: `La taille du fichier est supérieur à la limite autorisée (${Math.floor(octetsToMegas(maxSize))}Mo).` });
};

export const Z_FILES = (args: ValidationFileArgs) => {
  const { requiredMessage } = args;
  return z
    .instanceof(FileList, { error: requiredMessage })
    .refine((list) => list.length > 0, { error: requiredMessage })
    .transform((list) => Array.from(list))
    .pipe(z.array(Z_FILE(args)));
};

export const Z_SAVED_FILE = (args: { errorMsg: string, maxSize: number }) => {
  const { maxSize, errorMsg } = args;
  return z.object({
    id: z.number().optional(),
    url: z.url().nullable(),
    name: z.string().min(1),
    type: z.string().min(1),
    size: z.number().max(maxSize, { error: `La taille du fichier est supérieur à la limite autorisée (${Math.floor(octetsToMegas(maxSize))}Mo).` }),
  }, { error: errorMsg });
};

interface ValidationFileArgs {
  requiredMessage: string;
  maxSize: number;
  fileTypes: string[];
  extensions: string[];
}